export const environment = {
  production: true,
  test: 'test prod',
  logo: 'assets/images/finsoft.png',
  favicon: 'assets/images/favicon.ico',
}
